module.exports = "varying vec2 vUv;\r\nvarying float noise;\r\nvarying vec3 fNormal;\r\nvarying vec4 vColor;\r\n\r\nuniform vec2 rippleOrigin;\r\nuniform float rippleSize;\r\n\r\nvoid main() {\r\n  vec3 light = vec3(1.0, 1.0, 1.0);\r\n  float dProd = max(0.0, dot(fNormal, light));\r\n\r\n  gl_FragColor = vec4(\r\n    vColor.x * dProd,\r\n    vColor.y * dProd,\r\n    vColor.z * dProd, \r\n    vColor.w\r\n  );\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/game/shaders/waves.frag
// module id = 16
// module chunks = 0